<template>
    <div class="company-link-list" v-if="companies && companies.length > 0">
        <div v-for="company in shownCompanies" :key="company.id">
            <router-link v-if="company.canView"
                         :to="'/company/view/' + company.id">
                {{ company.name }}
            </router-link>
            <template v-else>{{ company.name }}</template>
        </div>
        <i v-if="otherCount > 0">And {{ otherCount }} more...</i>
    </div>
</template>

<script>
import Authorization from '@/providers/Authorization'
import Vue from 'vue'

export default {
    name: 'CompanyLinkList',
    props: {
        companies: Array,
    },
    computed: {
        shownCompanies () {
            return this.companies.slice(0, 2)
        },
        otherCount () {
            return this.companies.length - 2
        }
    },
    created () {
        if (this.companies) {
            this.companies.forEach((company) => {
                Authorization.can({ action: 'view', model: 'company', arg: company.id }).then((can) => {
                    Vue.set(company, 'canView', can)
                })
            })
        }
    },
}
</script>

<style scoped>

</style>